<template>
  <!-- Follows the score CTA card, which carries the spacing above, so it starts flush. -->
  <sec-section labelledby="about-team" flush :divider="false">
    <sec-section-heading id="about-team" :title="team.title" underline />
    <sec-team-grid :members="team.members" :linkedin-label="team.linkedinLabel" />
  </sec-section>
</template>

<script setup>
import SecSection from '@/components/security/ui/SecSection.vue';
import SecSectionHeading from '@/components/security/ui/SecSectionHeading.vue';
import SecTeamGrid from '@/components/security/ui/SecTeamGrid.vue';
import { ABOUT } from '@/content/security/about';

const team = ABOUT.team;
</script>
